/* eslint-disable */
export default {
  activeCall: 'アクティブな通話',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
